import React, { Component } from 'react';
import logo from '../../../../images/LOGO_PATHE.png';
import waiting0 from '../../../../images/giphy-0.gif';
import waiting1 from '../../../../images/giphy-1.gif';
import waiting2 from '../../../../images/giphy-2.gif';
import waiting3 from '../../../../images/giphy-3.gif';
import waiting4 from '../../../../images/giphy-4.gif';
import waiting5 from '../../../../images/giphy-5.gif';
import waiting6 from '../../../../images/giphy-6.gif';
import waiting7 from '../../../../images/giphy-7.gif';
import waiting8 from '../../../../images/giphy-8.gif';
import waiting9 from '../../../../images/giphy-9.gif';
import waiting10 from '../../../../images/giphy-10.gif';
import Config from "../../../../config/config";

export default class WaitingDevice extends Component {

	constructor(props) {
		super(props);

		console.log("WaitingDevice:");
	}

	componentDidMount() {
		window.scrollTo(0, 0);

		window.gtag('config', Config.googleAnalyticsCode, {
			'page_title' : 'Waiting',
			'page_path': '/waiting'
		});
	}

	getThemeStyle(questionConfig) {
		let themeStyle = {};

		themeStyle.topLogoImage = questionConfig.theme_device_top_logo ? questionConfig.theme_device_top_logo : logo;
		themeStyle.bottomLogoStyle = questionConfig.theme_device_bottom_logo ? {backgroundImage: "url('" + questionConfig.theme_device_bottom_logo + "')"} : null;
		themeStyle.curtainsStyle = questionConfig.theme_device_curtains ? {backgroundImage: "url('" + questionConfig.theme_device_curtains + "')"} : null;
		themeStyle.backgroundImage = questionConfig.theme_device_background_image ? {backgroundImage: "url('" + questionConfig.theme_device_background_image + "')"} : null;

		themeStyle.screenStyle = {};
		if (questionConfig.theme_device_font) themeStyle.screenStyle.fontFamily = questionConfig.theme_device_font;
		if (questionConfig.theme_device_text_color) themeStyle.screenStyle.color = "#" + questionConfig.theme_device_text_color;
		if (questionConfig.theme_device_background_image) {
			themeStyle.screenStyle.backgroundImage = "url('" + questionConfig.theme_device_background_image + "')";
			themeStyle.screenStyle.position = "absolute";		
			themeStyle.screenStyle.height = "100vh";
			themeStyle.screenStyle.backgroundSize = "contain";
		}
		return themeStyle;
	}


	render() {
		let themeStyle = {
			topLogoImage: logo,
			screenStyle: {},
		}; 
		if (this.props.question) {
			themeStyle = this.getThemeStyle(this.props.question);
		}

		const waiting = [waiting0, waiting1, waiting2, waiting3, waiting4, waiting5, waiting6, waiting7, waiting8, waiting9, waiting10][Math.floor(Math.random()*11)];
		return (
			<div className="answers waitingDevice" style={themeStyle.screenStyle}>
				<div className="container">
					<div className="logo" ><img src={themeStyle.topLogoImage} width="100%" alt="logo" /></div>
				</div>
				<div className="waiting-text">WACHTEN OP ANDERE SPELERS</div>
				<img src={waiting} style={{width:"100%"}} alt="Wachten..." />
				<div className="curtains" style={themeStyle.curtainsStyle}></div>
			</div>
		)
	}
}




// WEBPACK FOOTER //
// ./src/components/pages/Quiz/WaitingDevice/WaitingDevice.js